import { axiosInstance } from '~/src/config/config_axios'

export class AdminRepository {
  async delete(adminId: number): Promise<void> {
    return axiosInstance.delete(`/admins/${adminId}`)
  }
}
